import Iconify from "minimals-template/components/Iconify"
import { getTreeRootElements } from "ioc"
import { inPriorityOrder } from "lib/in-priority-order"
import { useMobile } from "lib/@components/mobile"
import noop from "lib/noop"
import { useCallback, useMemo, useRef, useState } from "react"
import { DecorateIndex, RefreshSchedules, RefreshTreeRoots, TreeRootsUpdated } from "event-definitions"
import { getTreeItemIndex } from "routes/schedule/lib/getTreeItemIndex"
import { setTreeIndex } from "routes/schedule/lib/getTreeIndex"
import { addDebugItem } from "debug-window"
import { debounce } from "lib/debounce"
import { noChange, useRefresh } from "lib/@hooks/useRefresh"
import { useBoundContext } from "lib/@components/binding/use-bound-context"

export function useTreeRoots() {
    const [roots, setRoots] = useState()
    const isMobile = useMobile()
    const reindexed = useRefresh(noChange)
    const { currentClient } = useBoundContext()
    const currentClientRef = useRef(currentClient)
    currentClientRef.current = currentClient

    // eslint-disable-next-line react-hooks/exhaustive-deps
    const refreshIndex = useCallback(
        debounce(async () => {
            const indexClient = currentClientRef.current
            try {
                const roots = await getTreeRootElements()
                const index = {}
                setTreeIndex(index, indexClient)
                getTreeItemIndex({ id: "_root", children: roots }, index)
                setRoots(roots.sort(inPriorityOrder))
                DecorateIndex.call({ index })
                TreeRootsUpdated.raiseOnce()
                RefreshSchedules.raiseOnce()
                reindexed()
                addDebugItem("Did update the tree index")
            } catch (e) {
                console.warn("Tree roots not available", e.message, e.stack)
            }
        }, 100),
        []
    )

    const refresh = RefreshTreeRoots.useRefresh(noChange)
    // eslint-disable-next-line react-hooks/exhaustive-deps
    useMemo(
        refreshIndex,
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [refresh.id]
    )
    return {
        children: roots,
        label: (
            <Iconify
                sx={{ fontSize: isMobile ? 16 : 24, mt: 0.5, lineHeight: 0 }}
                icon="material-symbols:home-rounded"
            />
        ),
        id: "_root",
        onExpand: noop,
        onCollapse: noop,
    }
}
